import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./Investorrelations.scss";
const Investorrelations = () => {
  return <CmsPage id={12} />;
};

export default Investorrelations;
